module.exports = __webpack_public_path__ + "img/txt_info2.accc47cf.png";